import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import parse from 'html-react-parser'
import Texteditor from "./Texteditor"
import axiosJWT from '../../JwtToken'

export const Edit = ({ rowID, getData, closeEdit, getPesan, setMsg }) => {

    const [potensialCode, setPotensialCode] = useState('')
    const [potensialName, setPotensialName] = useState('')
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [information, setInformation] = useState('')
    const [files, setFiles] = useState([null, null, null, null, null])
    const [previews, setPreviews] = useState([null, null, null, null, null])
    const [data, setData] = useState([])
    const [editorLoaded, setEditorLoaded] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        getKegiatan()
        getPotencial()
        setEditorLoaded(true)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getPotencial = async (key) => {
        try {
            const response = await axiosJWT.post("/api/kegiatan-usaha/publish", {
                key: key
            })
            setData(response.data)
        } catch (err) {
            getPesan()
            setMsg(err.response.data.msg ? err.response.data.msg : 'Data tidak terkirim, mohon coba lagi!')
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        }
    }

    const getPotencialName = async (code) => {
        const response = await axiosJWT.post('/api/kegiatan-usaha/filter', {
            code,
            jml: 1
        })
        setPotensialCode(code)
        setPotensialName(response.data[0].name)
    }

    const getKegiatan = async () => {
        const response = await axiosJWT.get(`/api/promotion/${rowID}`)
        const promo = response.data // Pake ini!

        setPotensialName(promo.potensialName)
        setPotensialCode(promo.potensialCode)
        setTitle(promo.title)
        setDescription(promo.description)
        setInformation(promo.information)

        // Pake promo.filePath, bukan data.filePath
        setPreviews([
            promo.filePath,
            promo.filePath2,
            promo.filePath3,
            promo.filePath4,
            promo.filePath5
        ])
    }

    const loadFile = (e, index) => {
        const file = e.target.files[0]
        const newFiles = [...files]
        newFiles[index] = file
        setFiles(newFiles)

        const newPreviews = [...previews]
        newPreviews[index] = URL.createObjectURL(file)
        setPreviews(newPreviews)
    }

    const getWaktuSekarang = () => {
        const d = new Date()
        const date = d.toISOString().split('T')[0] // Hasil: 2024-06-06
        const time = d.toTimeString().split(' ')[0] // Hasil: 09:59:42
        return `${date} ${time}`
    }

    const proses = async (e) => {
        e.preventDefault()

        try {
            const tanggal = getWaktuSekarang()
            const formData = new FormData()
            formData.append("potensialCode", potensialCode)
            formData.append("potensialName", potensialName)
            formData.append("title", title)
            formData.append("description", description)
            formData.append("tanggal", tanggal)

            files.forEach((file, i) => {
                if (file) {
                    const fieldName = (i === 0) ? 'file' : `file${i + 1}`
                    formData.append(fieldName, file)
                }
            })

            const response = await axiosJWT.put(`/api/promotion/${rowID}`, formData)

            // 2. Success Feedback
            getPesan()
            setMsg(response.data.msg)

            setTimeout(() => {
                getPesan()
                setMsg('')
                getData('')
                closeEdit()
            }, 2000)

        } catch (err) {
            getPesan()
            const errorMsg = (err.response && err.response.data && err.response.data.msg)
                ? err.response.data.msg
                : 'Maaf, proses pengiriman data gagal!'
            setMsg(errorMsg)

            setTimeout(() => {
                getPesan()
                setMsg('')
            }, 4000)
        }
    }

    return (<>
        <form onSubmit={proses} className="form-horizontal">
            <h5 className="right-line color-success">Promosi</h5>
            <div className="row">
                <div className="form-group col-md-6">
                    <label className="control-label">Kegiatan Usaha</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-filter"></i></span>
                        <select className="form-control" value={potensialCode} onChange={(e) => getPotencialName(e.target.value)}>
                            <option value="">==</option>
                            {data.map((row, i) => (
                                <option key={i} value={row.potensialCode}>{i + 1}. {row.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Judul</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-newspaper-o"></i></span>
                        <input type="text" className="form-control" onChange={(e) => setTitle(e.target.value)} value={title} required />
                    </div>
                </div>
                <div className="form-group col-md-12">
                    <label className="control-label">File Pendukung</label>
                    <div className="row">
                        {[0, 1, 2, 3, 4].map((i) => (
                            <div key={i} className="col-md-2" style={{ marginBottom: '10px' }}>
                                <img
                                    src={previews[i] || "/assets/img/no-image.png"}
                                    style={{ width: '100%', height: '80px', objectFit: 'cover', border: '1px solid #ddd' }}
                                    alt="preview"
                                />
                                {/* Tambahin onChange={(e) => loadFile(e, i)} di sini */}
                                <input
                                    className="form-control"
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => loadFile(e, i)}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="form-group col-md-12">
                    <label className="control-label">Deskripsi</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-info"></i></span>
                        <Texteditor onChange={(description) => { setDescription(description) }} editorLoaded={editorLoaded} value={description || ''} required />
                    </div>
                </div>
            </div>
            {information ? (<>
                <h5 className="right-line color-success">Keterangan Status</h5>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label className="control-label">Keterangan</label>
                        <div className="input-group">
                            <span className="input-group-addon"><i className="fa fa-info"></i></span>
                            {parse(information)}
                        </div>
                    </div>
                </div>
            </>) : null}
            <div className="modal-footer">
                <button className="btn btn-raised btn-success br-2 no-m" type="Submit"><i className="fa fa-edit"></i> Update</button>
                <button onClick={closeEdit} className="btn btn btn-raised btn-danger br-2 no-m">
                    <i className="fa fa-sign-out"></i> Tutup
                </button>
            </div>
        </form>
    </>)
}